<template>
    <div class="company-edit">
        <data-form :title="title"
                   tag="company-edit"
                   save-button-label="Save"
                   :field-model="companyFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :cancelRoute="`/company/view/${companyId}`"
                   submit-success-message="Company updated"
                   submit-error-message="Error updating company"
                   :submit-success-route="`/company/view/${companyId}`">
        </data-form>
    </div>
</template>

<script>
import Vue from 'vue'
import CompanyFields from '@/models/Company'

export default Vue.extend({
    name: 'CompanyEdit',
    props: {
        companyId: Number,
    },
    data () {
        return {
            title: 'Edit Company',
            companyFields: CompanyFields,
            fieldGroups: [
                ['id', 'name', 'ccb_number', 'alt_license', 'alt_license_type', 'alt_license_number', 'url', 'cobid_certified', 'cobid_number', 'cobid_types'],
                ['mailing_address', 'city', 'state', 'zip'],
            ],
        }
    },
    methods: {
        async loadModelInstance () {
            return this.$api.getItem(this, 'company', this.companyId)
                .then((company) => {
                    this.title = 'Edit ' + company.name
                    return company
                })
        },
        onSubmit (modelInstance) {
            return this.$api.updateItem(this, 'company', modelInstance)
        },
    }
})
</script>

<style lang="scss">
.company-edit {
    max-width: 1600px;
    margin: 0 auto;
}
</style>